// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YYde1","left":"styles_left__2lSv6"};